import { FaEye } from 'react-icons/fa6';
import { useRetainHistoryContext } from '../../../contexts/RetainHistoryProvider';
import { RetainAgreement } from '../../../types/retain';

const ShowRetainDetailsBtn = ({
  retainHistory,
}: {
  retainHistory: RetainAgreement;
}) => {
  // integration of context hooks here
  const { setSelectedRetainHistory, setShowDetailsModal } =
    useRetainHistoryContext();

  // rendering retain details button component here
  return (
    <div className='flex items-center justify-center'>
      <button
        type='button'
        onClick={() => {
          setSelectedRetainHistory(retainHistory);
          setShowDetailsModal(true);
        }}
        className='flex items-center justify-center gap-1 bg-base-light-blue rounded-md px-4 py-1 text-base-white text-sm hover:opacity-70 active:scale-95 duration-300'
      >
        <FaEye />
        <span>View Details</span>
      </button>
    </div>
  );
};

export default ShowRetainDetailsBtn;
